import React, { Component } from 'react'
import { connect } from 'react-redux'
import BkFlowEnhancementsCards from './elements/BkFlowEnhancementsCards'
import BkFlowRestaurantsCards from '../restaurants/BkFlowRestaurantsCards'

import BkFlowError from '../elements/BkFlowError'
import BkFlowLoader from '../elements/BkFlowLoader'

import setActiveStep from '../../actions/activeStepActions'
import triggerCustomGaEvent from '../../utilities/analytics/triggerCustomGaEvent'

import yn from 'yn'
import _ from 'lodash'

import backArrow from '../../assets/icons/arrow-left.svg'

import '../../styles/css/components/enhancements/bk-flow-enhancements.css'
import BkFlowStructuredSidebarSkipStepButton from "../structure/sidebar/elements/BkFlowStructuredSidebarSkipStepButton";


class BkFlowPreEnhancements extends Component {
	constructor(props) {
		super(props)
		this.state = {
		}
	}

	componentDidMount() {
		window.history.pushState( {} , '', '/book/enhance?' + this.props.currentQuery.query )

		if (process.env.REACT_APP_COMPONENT_ENHANCEMENTS_CONTENT_WIDTH === 'full') {
			document.getElementById('bk-flow-enhancements-container').classList.add('u-container--full')
		} else if (yn(process.env.REACT_APP_COMPONENT_ENABLE_STRUCTURED_SIDEBAR)) {
			document.getElementById('bk-flow-enhancements-container').classList.remove('u-container')
		}

		// Dispatch activeRoom GA events
		triggerCustomGaEvent('analytics-pageView', window.location.href)
	}

	render() {
		const {
			activeEnhancementData,
			activeStep,
			availabilityData,
			configData,
			enhancementData,
			handleBreadcrumbStep,
			handleContinuePayment,
			restaurantData,
		} = this.props
		const hotelLabels = configData.hotel.labels[0]

		return (
			<div
				id="bk-flow-enhancements-container"
				className="bk-flow-enhancements__container u-container"
			>
				{yn(process.env.REACT_APP_COMPONENT_ENABLE_STRUCTURED_SIDEBAR_SKIP_STEP_BUTTON) &&
				<div className="bk-flow-enhancements__mobile-step-toggle">
					<BkFlowStructuredSidebarSkipStepButton
						activeEnhancementData={activeEnhancementData}
						activeStep={activeStep}
						handleContinuePayment={handleContinuePayment}
						hotelLabels={hotelLabels}
					/>
				</div>
				}

				{ (yn(process.env.REACT_APP_COMPONENT_ENHANCEMENTS_HEADING) || yn(process.env.REACT_APP_COMPONENT_ENHANCEMENTS_HEADING_CTA)) &&
				<div className="bk-flow-enhancements__header row center-xs middle-xs">
					<div className="bk-main-header row middle-xs center-xs">
						{ yn(process.env.REACT_APP_COMPONENT_ENHANCEMENTS_HEADING) &&
						<h2 className={enhancementData.loading ? 'bk-flow-enhancements__title u-remove-margin' : 'bk-flow-enhancements__title'} >
							{ yn(process.env.REACT_APP_COMPONENT_BREADCRUMB_BACK_BUTTONS) &&
							<button
								className="btn btn-text-only"
								onClick={() => handleBreadcrumbStep(activeStep - 1)}
							>
								<img src={ backArrow } alt="Return to rooms page" />
								{ hotelLabels && hotelLabels.backToRooms ? hotelLabels.backToRooms : 'Back to Rooms' }
							</button>
							}

							{ hotelLabels.enhanceYourStay ? hotelLabels.enhanceYourStay : 'Enhance Your Stay'}
						</h2>
						}

						{ !enhancementData.loading && yn(process.env.REACT_APP_COMPONENT_ENHANCEMENTS_HEADING_CTA) &&
						<div
							className="bk-flow-enhancements__submit-btn btn btn-transparent u-bg-white"
							onClick={() => handleContinuePayment(activeStep)}
							tabIndex={0}
						>
							<span>{ hotelLabels.continuePayment ? hotelLabels.continuePayment : 'Continue to Payment' }</span>
						</div>
						}
					</div>
				</div>
				}

				{ yn(process.env.REACT_APP_COMPONENT_ENABLE_RESTAURANT_RESERVATIONS) &&
				!_.isEmpty(restaurantData.restaurants) &&
				!enhancementData.loading &&
				<BkFlowRestaurantsCards
					activeStep={ activeStep }
					handleContinuePayment={ handleContinuePayment }
				/>
				}

				<div className="bk-flow-enhancements__content row">
					<div className="bk-flow-enhancements">
						{ enhancementData.loading ?
							<BkFlowLoader />
							:
							<div className="bk-flow-enhancements__cards">
								<BkFlowEnhancementsCards />
							</div>
						}
					</div>

					{ enhancementData.error &&
					<BkFlowError
						configData={ configData}
						availabilityData={ availabilityData }
						parentClasses="bk-flow-enhancements__errors col-xs"
						errorMessage="There was an issue retrieving room add ons - please wait a moment, and try again - or continue with your booking."
						requestError={ enhancementData.error.message}
					/>
					}
				</div>

				{ !enhancementData.loading &&
					<div className="bk-flow-enhancements__footer row middle-xs center-xs">
						<BkFlowStructuredSidebarSkipStepButton
							activeEnhancementData={activeEnhancementData}
							activeStep={activeStep}
							handleContinuePayment={handleContinuePayment}
							hotelLabels={hotelLabels}
						/>
					</div>
				}
			</div>
		)
	}
}

function mapStateToProps(state) {
	return {
	currentQuery: state.availabilityData.currentQuery,
	configData: state.configData.configuration,
	urlData: state.availabilityData.urlData,
	restaurantData: state.restaurantData,
	enhancementData: state.enhancementData,
	availabilityData: state.availabilityData,
	activeRoom: state.activeRoomData,
	activeEnhancementData: state.activeEnhancementData,
	activeStep: state.activeStepData.activeStep,
	activeGuest: state.form.guestForm,
	activePayment: state.form.paymentForm,
	activeCreditType: state.activeCreditData.creditType
}
}

const mapDispatchToProps = dispatch => ({
	handleBreadcrumbStep(activeStep) {
		return dispatch(setActiveStep(activeStep))
	},
	handleContinuePayment(activeStep) {
		// Dispatch step update
		return dispatch(setActiveStep(activeStep + 1))
	}
})

export default connect(mapStateToProps, mapDispatchToProps)(BkFlowPreEnhancements)


// WEBPACK FOOTER //
// ./src/components/enhancements/BkFlowPreEnhancements.js